var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_radial_315_34)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08239 2.77273V2.46591L2.66761 1.54545H2.94602V1.95455H2.78693L2.47159 2.45455V2.46591H3.33523V2.77273H2.08239ZM2.78977 3V2.67898L2.7983 2.54545V1.54545H3.16761V3H2.78977Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_315_34",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.5 2.5) rotate(90) scale(2.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#66FF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall4);
export default __webpack_public_path__ + "static/media/ball4.2356869804568d5f901e7547769d824c.svg";
export { ForwardRef as ReactComponent };